import React, { useState } from 'react';
import { Sidebar } from '../../components/Sidebar';
import { Header } from '../../components/Header';
import { UploadIcon, SearchIcon, FilterIcon, MoreHorizontalIcon, DownloadIcon, EyeIcon, FileIcon, ImageIcon, TypeIcon, PaletteIcon, LayoutTemplateIcon } from 'lucide-react';
import { BRAND_ASSETS } from '../../data/brandMockData';
import { UploadAssetModal } from '../../components/brand/UploadAssetModal';
export function BrandAssets() {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');
  const [isUploadAssetOpen, setIsUploadAssetOpen] = useState(false);
  const categories = [{
    id: 'All',
    label: 'All Assets',
    icon: null
  }, {
    id: 'Logo',
    label: 'Logos',
    icon: ImageIcon
  }, {
    id: 'Color',
    label: 'Colors',
    icon: PaletteIcon
  }, {
    id: 'Typography',
    label: 'Typography',
    icon: TypeIcon
  }, {
    id: 'Photography',
    label: 'Photography',
    icon: ImageIcon
  }, {
    id: 'Template',
    label: 'Templates',
    icon: LayoutTemplateIcon
  }];
  const filteredAssets = BRAND_ASSETS.filter(asset => {
    const matchesCategory = selectedCategory === 'All' || asset.category === selectedCategory;
    const matchesSearch = asset.name.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });
  return <div className="flex w-full min-h-screen bg-gray-50" data-id="element-1749">
      <Sidebar data-id="element-1750" />
      <main className="flex-1 overflow-y-auto" data-id="element-1751">
        <Header data-id="element-1752" />
        <div className="px-8 py-8" data-id="element-1753">
          <div className="flex items-center justify-between mb-8" data-id="element-1754">
            <div data-id="element-1755">
              <h1 className="text-2xl font-bold text-gray-900" data-id="element-1756">Brand Assets</h1>
              <p className="text-gray-500 mt-1" data-id="element-1757">
                Centralized library for all brand materials and guidelines
              </p>
            </div>
            <button onClick={() => setIsUploadAssetOpen(true)} className="flex items-center gap-2 px-4 py-2 bg-blue-600 rounded-lg text-sm font-medium text-white hover:bg-blue-700 shadow-sm" data-id="element-1758">
              <UploadIcon size={16} data-id="element-1759" />
              Upload Asset
            </button>
          </div>

          <div className="flex gap-6" data-id="element-1760">
            {/* Sidebar Filters */}
            <div className="w-64 flex-shrink-0" data-id="element-1761">
              <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-4" data-id="element-1762">
                <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-4 px-2" data-id="element-1763">
                  Categories
                </h3>
                <div className="space-y-1" data-id="element-1764">
                  {categories.map(category => {
                  const Icon = category.icon;
                  return <button key={category.id} onClick={() => setSelectedCategory(category.id)} className={`w-full flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${selectedCategory === category.id ? 'bg-blue-50 text-blue-700' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-1765">
                        {Icon && <Icon size={16} data-id="element-1766" />}
                        {category.label}
                        {selectedCategory === category.id && <span className="ml-auto bg-blue-200 text-blue-800 text-xs py-0.5 px-2 rounded-full" data-id="element-1767">
                            {category.id === 'All' ? BRAND_ASSETS.length : BRAND_ASSETS.filter(a => a.category === category.id).length}
                          </span>}
                      </button>;
                })}
                </div>
              </div>
            </div>

            {/* Main Content */}
            <div className="flex-1" data-id="element-1768">
              {/* Search Bar */}
              <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-4 mb-6 flex items-center gap-4" data-id="element-1769">
                <div className="relative flex-1" data-id="element-1770">
                  <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} data-id="element-1771" />
                  <input type="text" placeholder="Search assets..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-1772" />
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-500" data-id="element-1773">
                  <FilterIcon size={16} data-id="element-1774" />
                  <span data-id="element-1775">Sort by: Newest</span>
                </div>
              </div>

              {/* Assets Grid */}
              <div className="grid grid-cols-3 gap-6" data-id="element-1776">
                {filteredAssets.map(asset => <div key={asset.id} className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden hover:shadow-md transition-shadow group" data-id="element-1777">
                    <div className="relative h-40 bg-gray-100 flex items-center justify-center overflow-hidden" data-id="element-1778">
                      <img src={asset.thumbnail} alt={asset.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" data-id="element-1779" />
                      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors flex items-center justify-center opacity-0 group-hover:opacity-100" data-id="element-1780">
                        <div className="flex gap-2" data-id="element-1781">
                          <button className="p-2 bg-white rounded-full text-gray-700 hover:text-blue-600 transition-colors" title="Preview" data-id="element-1782">
                            <EyeIcon size={18} data-id="element-1783" />
                          </button>
                          <button className="p-2 bg-white rounded-full text-gray-700 hover:text-blue-600 transition-colors" title="Download" data-id="element-1784">
                            <DownloadIcon size={18} data-id="element-1785" />
                          </button>
                        </div>
                      </div>
                      <div className="absolute top-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-1786">
                        <button className="p-1.5 bg-white/90 backdrop-blur-sm rounded-full text-gray-600 hover:text-gray-900 shadow-sm" data-id="element-1787">
                          <MoreHorizontalIcon size={16} data-id="element-1788" />
                        </button>
                      </div>
                    </div>

                    <div className="p-4" data-id="element-1789">
                      <div className="flex items-start justify-between mb-2" data-id="element-1790">
                        <div data-id="element-1791">
                          <h3 className="text-sm font-semibold text-gray-900 line-clamp-1" title={asset.name} data-id="element-1792">
                            {asset.name}
                          </h3>
                          <p className="text-xs text-gray-500" data-id="element-1793">
                            {asset.fileType} • {asset.size}
                          </p>
                        </div>
                        <span className="px-2 py-0.5 bg-gray-100 text-gray-600 text-[10px] font-medium rounded-full uppercase" data-id="element-1794">
                          {asset.category}
                        </span>
                      </div>

                      <div className="flex items-center justify-between pt-3 border-t border-gray-100 mt-3" data-id="element-1795">
                        <span className="text-xs text-gray-400" data-id="element-1796">
                          Uploaded {asset.uploadedDate}
                        </span>
                        <div className="flex items-center text-xs text-gray-500" data-id="element-1797">
                          <DownloadIcon size={12} className="mr-1" data-id="element-1798" />
                          {asset.downloads}
                        </div>
                      </div>
                    </div>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </main>

      <UploadAssetModal isOpen={isUploadAssetOpen} onClose={() => setIsUploadAssetOpen(false)} data-id="element-1799" />
    </div>;
}